console.log('Welcome to the Outbound Platform');

import { checkBrowserAndGetRedirect } from "@/util/compat";

// Pre-set Debug
window.isDebug = (process.env.NODE_ENV == 'development');
if (window.isDebug) {
	console.log('Development Mode');
}

//It works best in Chrome
let redirect = null;
if (redirect = checkBrowserAndGetRedirect({
	changeRoute: 'changeBrowser',
	continueRoute: 'accounts'
})) {
	window.location = redirect;
}

// Includes
require('./bootstrap');